import { useContext } from 'react';

import { ToastContext, type ToastState } from '@yoweb/ui/contexts/toast/ToastContext';

/**
 * Hook for error, success and generic toast messages.
 */
export function useToast(): ToastState {
  const toast = useContext(ToastContext);

  if (!toast) {
    throw new Error('useToast must be used within a ToastContextProvider');
  }

  return toast;
}
